import { sql } from 'drizzle-orm'
import { pgTable, text, timestamp, uuid, varchar } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'
import z from 'zod/v4'

export const File = pgTable('file', {
  id: uuid().notNull().primaryKey().defaultRandom(),
  key: text().notNull(),
  extension: varchar({ length: 5 }).notNull(),
  fileName: varchar({ length: 256 }).notNull(),
  mimeType: varchar({ length: 256 }).notNull(),
  bucket: varchar({ length: 256 }).notNull(),
  url: text(),
  createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
})

export const InsertFileSchema = createInsertSchema(File, {
  key: z.string(),
  extension: z.string().max(5),
  fileName: z.string().max(256),
  mimeType: z.string().max(256),
  bucket: z.string().max(256),
}).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateFileSchema = createUpdateSchema(File, {
  key: z.string(),
  extension: z.string().max(5),
  fileName: z.string().max(256),
  mimeType: z.string().max(256),
  bucket: z.string().max(256),
})
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .partial()

export const SelectFileSchema = createSelectSchema(File, {
  id: z.uuid(),
  key: z.string(),
  extension: z.string().max(5),
  fileName: z.string().max(256),
  mimeType: z.string().max(256),
  bucket: z.string().max(256),
  createdAt: z.date(),
  updatedAt: z.date(),
})

export type InsertFile = typeof File.$inferInsert
export type UpdateFile = z.infer<typeof UpdateFileSchema>
export type SelectFile = typeof File.$inferSelect
